import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("close", () => {
      const computedStyle = window.getComputedStyle(this.element);
      const duration = computedStyle.getPropertyValue('transition-duration');
      let timeoutMs = 0;
      if (duration.includes('ms')) {
        timeoutMs = parseFloat(duration);
      } else if (duration.includes('s')) {
        timeoutMs = parseFloat(duration) * 1000;
      }

      setTimeout(() => {
        if (this.element) this.element.remove()
      }, timeoutMs);
    })
  }
}